import type { CategoryType } from 'redux/Api/employedsApi/type';

export function mergeSelectedCategoriesForStore(
  selectedIds: string[],
  loadedCategories: CategoryType[] | undefined,
  previousCategories: CategoryType[] | undefined,
): CategoryType[] {
  const loadedById = new Map(
    (loadedCategories ?? []).map((c) => [String(c.id), c] as const),
  );
  const previousById = new Map(
    (previousCategories ?? []).map((c) => [String(c.id), c] as const),
  );

  const result: CategoryType[] = [];
  for (const id of selectedIds) {
    const fromLoaded = loadedById.get(id);
    if (fromLoaded) {
      result.push(fromLoaded);
      continue;
    }
    const fromPrevious = previousById.get(id);
    if (fromPrevious) {
      result.push(fromPrevious);
    }
  }
  return result;
}
